import { useContext } from 'react'

import { ModalType } from '@/components/view/layouts/modal/Modal'
import Modal from '@/components/view/layouts/modal/Modal'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import MediaAnalysisAutomationSettingsForm from '@/components/container/form/modules/media/analysisAutomation/MediaAnalysisAutomationSettingsForm'
import { MediaAnalysisAutomationSettingsModalContext } from '@/components/container/modal/mediaAnalysisAutomation/MediaAnalysisAutomationSettingsModalProvider'

const MediaAnalysisAutomationSettingsModal = () => {
  const { modal, showing, hide } = useContext(MediaAnalysisAutomationSettingsModalContext)

  return (
    <Modal show={showing} type={ModalType.MIDDLE}>
      <ModalHeader text={`自動実行設定`} onClickClose={hide} />
      {modal.showing && modal.item && (
        <MediaAnalysisAutomationSettingsForm
          siteId={modal.siteId}
          item={modal.item}
          onSaved={() => {
            modal.onSaved()
            hide()
          }}
          onCancel={hide}
          forEnabling={modal.forEnabling ?? false}
        />
      )}
    </Modal>
  )
}

export default MediaAnalysisAutomationSettingsModal
